// extracted by mini-css-extract-plugin
export default {"viewMore":"see-more-module__viewMore__UAGCS"};